// extracted by mini-css-extract-plugin
export default {"avatar":"Avatar_avatar__JkbX0","img":"Avatar_img__ejFKe","removeBtn":"Avatar_removeBtn__fHaM2","editBtn":"Avatar_editBtn__X97r5"};